import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';

const ProjectsSection = () => {
  const navigate = useNavigate();

  return (
    <section id="projects" className="py-24 px-6 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-96 h-96 rounded-full blur-3xl opacity-10" style={{ background: '#F97316' }} />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-primary">Projects</h2>
          <p className="text-lg max-w-2xl mx-auto text-foreground-secondary">
            Showcasing innovation in action
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="max-w-4xl mx-auto">
          <div className="glass-frosted rounded-3xl p-16 text-center glow-subtle">
            <div className="flex justify-center mb-8">
              <div
                className="w-24 h-24 rounded-2xl flex items-center justify-center animate-pulse"
                style={{
                  background: 'rgba(249, 115, 22, 0.1)',
                  border: '1px solid rgba(249, 115, 22, 0.3)',
                }}
              >
                <Clock size={48} style={{ color: '#F97316' }} />
              </div>
            </div>
            <h3 className="text-4xl font-bold text-foreground-primary mb-6">Coming Soon</h3>
            <p className="text-xl mb-8 max-w-2xl mx-auto text-foreground-secondary">
              We're preparing detailed case studies of our breakthrough projects. Stay tuned for real-world applications
              and success stories from the field.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="px-8 font-semibold transition-smooth group"
                style={{
                  background: '#F97316',
                  color: '#FFFFFF',
                }}
                onClick={() => navigate('/contact')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 0 40px rgba(249, 115, 22, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Get Early Access
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
            </div>
          </div>

          {/* Preview Grid */}
          <div className="grid md:grid-cols-3 gap-6 mt-8">
            {[
              { title: 'Oil Pipeline Inspection', status: 'In Progress' },
              { title: 'Metro Tunnel Survey', status: 'Planning' },
              { title: 'Gas Infrastructure', status: 'Planning' },
            ].map((project, index) => (
              <div
                key={index}
                className="glass-effect rounded-xl p-6 border transition-smooth "
                className="border-subtle"
              >
                <div className="h-32 rounded-lg mb-4 flex items-center justify-center" style={{ background: 'rgba(249, 115, 22, 0.05)' }}>
                  <Clock size={32} style={{ color: '#F97316', opacity: 0.5 }} />
                </div>
                <h4 className="text-lg font-semibold text-foreground-primary mb-2">{project.title}</h4>
                <div
                  className="inline-block px-3 py-1 rounded-full text-xs font-medium"
                  style={{
                    background: 'rgba(249, 115, 22, 0.1)',
                    color: '#F97316',
                  }}
                >
                  {project.status}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;